import { WrapItem, Avatar, useDisclosure, Box, Flex } from "@chakra-ui/react";
import React from "react";
import ModalComponent from "../modal";

const AvatarComponent = ({ name, image, size = "md" }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <WrapItem
        onClick={(e) => {
          e.stopPropagation();
          onOpen();
        }}
        cursor={"pointer"}
      >
        <Avatar size={size} name={name} src={image} />
      </WrapItem>

      <ModalComponent
        isOpen={isOpen}
        onClose={() => false}
        size={"md"}
        title={""}
        closeBtn={true}
        closeModal={onClose}
      >
        {image && image.includes("http") ? (
          <Flex justifyContent={"center"}>
            <Box
              bgImage={image}
              w={"300px"}
              h={"300px"}
              bgRepeat={"no-repeat"}
              bgSize={"cover"}
              bgPos={"center"}
            ></Box>
          </Flex>
        ) : (
          <WrapItem justifyContent={"center"}>
            <Avatar size="2xl" name={name} src={image} />
          </WrapItem>
        )}
      </ModalComponent>
    </>
  );
};

export default AvatarComponent;
